import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";

/** Turmas do integral com seu professor; usada por Presença, Rotina e Professor. */
const IntegralProfessorTable = ({ listaIP, setIntegralProfessor }) => {
  if (listaIP.length === 0) {
    return (
      <Box
        sx={{
          py: 6,
          textAlign: "center",
          color: "text.secondary",
          border: 1,
          borderStyle: "dashed",
          borderColor: "divider",
          borderRadius: 2,
        }}
      >
        <GroupsOutlinedIcon fontSize="large" />
        <Typography variant="body2" mt={1}>
          Nenhuma turma do integral cadastrada.
        </Typography>
      </Box>
    );
  }

  return (
    <TableContainer sx={{ border: 1, borderColor: "divider", borderRadius: 2 }}>
      <Table size="small" aria-label="Turmas do integral">
        <TableHead>
          <TableRow sx={{ "& th": { fontWeight: 600, bgcolor: "action.hover" } }}>
            <TableCell>Turma</TableCell>
            <TableCell>Professor</TableCell>
            <TableCell sx={{ width: 48 }} />
          </TableRow>
        </TableHead>
        <TableBody>
          {listaIP.map((integralProfessor) => (
            <TableRow
              key={integralProfessor.codigo}
              hover
              onClick={() => setIntegralProfessor(integralProfessor)}
              sx={{ cursor: "pointer" }}
            >
              <TableCell>
                <Typography variant="body2" fontWeight={500}>
                  {integralProfessor.turma?.descricao}
                </Typography>
              </TableCell>
              <TableCell>{integralProfessor.usuario?.nome ?? "--"}</TableCell>
              <TableCell align="right">
                <ChevronRightIcon fontSize="small" color="action" />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default IntegralProfessorTable;
